import { z } from 'zod';

export const userSigninCredentialsSchema = z.object({
  userName: z.string().trim().min(1, 'Username is required'),

  password: z.string().min(1, 'Password is required'),
   turnstileToken: z
  .string()
  .min(1, 'Please complete the security verification.'),
});

export type UserSigninCredentialsFormValues = z.infer<typeof userSigninCredentialsSchema>;
